export default __webpack_public_path__ + "static/media/CV.233cce98.pdf";